import React, { useState, useEffect } from 'react';
import FullscreenWrapper from '../common/FullscreenWrapper';
import { View, Text, TouchableOpacity, StyleSheet, ScrollView } from 'react-native';
import PoiFormPlaceholder from './placeholders/PoiFormPlaceholder';
import RestaurantEditorView from './RestaurantEditorView';
import TransportFormPlaceholder from './placeholders/TransportFormPlaceholder';
import LodgingFormPlaceholder from './placeholders/LodgingFormPlaceholder';
import ActivityFormPlaceholder from './placeholders/ActivityFormPlaceholder';
import ShoppingFormPlaceholder from './placeholders/ShoppingFormPlaceholder';
import OtherFormPlaceholder from './placeholders/OtherFormPlaceholder';
import MeetingFormPlaceholder from './placeholders/MeetingFormPlaceholder';

export type CardType =
  | 'poi'
  | 'restaurant'
  | 'transport'
  | 'lodging'
  | 'activity'
  | 'shopping'
  | 'meeting'
  | 'other';

export interface CardFormHostProps {
  visible: boolean;
  cardType: CardType | null;
  initialData?: any;
  onSave?: (data: any) => void;
  onClose?: () => void;
}

const CardFormHost: React.FC<CardFormHostProps> = ({ visible, cardType, initialData, onSave, onClose }) => {
  const [formData, setFormData] = useState<any>(initialData || {});

  useEffect(() => {
    setFormData(initialData || {});
  }, [initialData]);
  const renderForm = () => {
    switch (cardType) {
      case 'poi':
        return <PoiFormPlaceholder initialData={initialData} onSave={onSave} onCancel={onClose} />;
      case 'restaurant':
        // Use unified RestaurantEditorView for both view and edit - keep local form state here
        return (
          <RestaurantEditorView
            mode={'edit'}
            data={formData}
            editableInline={true}
            onChange={(patch: any) => setFormData((prev) => ({ ...(prev || {}), ...(patch || {}) }))}
            onSave={() => onSave && onSave(formData)}
            onCancel={onClose}
          />
        );
      case 'transport':
        return <TransportFormPlaceholder initialData={initialData} onSave={onSave} onCancel={onClose} />;
      case 'lodging':
        return <LodgingFormPlaceholder initialData={initialData} onSave={onSave} onCancel={onClose} />;
      case 'activity':
        return <ActivityFormPlaceholder initialData={initialData} onSave={onSave} onCancel={onClose} />;
      case 'shopping':
        return <ShoppingFormPlaceholder initialData={initialData} onSave={onSave} onCancel={onClose} />;
      case 'meeting':
        return <MeetingFormPlaceholder initialData={initialData} onSave={onSave} onCancel={onClose} />;
      default:
        return <OtherFormPlaceholder initialData={initialData} onSave={onSave} onCancel={onClose} />;
    }
  };

  return (
    <FullscreenWrapper visible={visible} onClose={onClose}>
      <ScrollView contentContainerStyle={styles.container}>{renderForm()}</ScrollView>
    </FullscreenWrapper>
  );
};

const styles = StyleSheet.create({
  container: { padding: 20, backgroundColor: '#fff', minHeight: 400 },
});

export default CardFormHost;
